export default "__VITE_ASSET__Dfvenv30__"